type ErrorTooltipProps = {
  show: boolean;
  message: string;
};

/** Absolute-positioned validation tooltip with arrow, shown above a form field. */
export function ErrorTooltip({ show, message }: ErrorTooltipProps) {
  if (!show) return null;
  return (
    <div className="absolute -top-10 left-0 z-50 flex w-full justify-start animate-in fade-in slide-in-from-bottom-1 duration-200">
      <div className="relative flex h-7 items-center justify-center whitespace-nowrap rounded-md bg-red-500 px-2.5 text-[11px] font-bold text-white shadow-float-panel">
        {message}
        <div className="absolute -bottom-1 left-4 h-2 w-2 -translate-x-1/2 -rotate-45 rounded-sm bg-red-500" />
      </div>
    </div>
  );
}
